import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IFloatingCTAModal extends IBaseElementProps {
	title?: string;
	/**
	 * @control richtext
	 */
	content?: string;
	logo?: IImage;
	gravityFormId?: number;
	children?: any;
}

const FloatingCTAModal: React.FC<IFloatingCTAModal> = ({
	id,
	className,
	classNames = [],
	title,
	content,
	logo,
	gravityFormId,
	children,
}) => {
	return (
		<div
			id={id}
			className={
				className ||
				cn(
					'floating-cta-modal__container py-5 pt-7 px-3 p-md-7 p-lg-9',
					...classNames,
				)
			}
		>
			<div className="floating-cta-modal__contianer-inner">
				<div className="floating-cta-modal__left">
					{title && <h2>{title}</h2>}
					{content && (
						<div dangerouslySetInnerHTML={{ __html: content }} />
					)}
					{logo && (
						<div className="floating-cta-modal__logo">
							<Image {...logo} />
						</div>
					)}
				</div>
				<div className="floating-cta-modal__right">
					{gravityFormId > 0 && children}
				</div>
			</div>
		</div>
	);
};

export default FloatingCTAModal;
